import { render, staticRenderFns } from "./status-picker.vue?vue&type=template&id=2b5ec2bd&"
import script from "./status-picker.vue?vue&type=script&lang=ts&"
export * from "./status-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports